<template>
  <div v-if="isShow" class="popFixed new-withdrawal-certify">
    <div class="masking" @click="closeBankPop" />
    <div id="tcConHeight" class="tcCon">
      <div class="item">
        <span>温馨提示</span>
        <p>为了您资金安全，首次提现，需要完成证明文件的认证:</p>
        <ul class="my-ul">
          <li>经银行卡取款，需身份证明及银行卡</li>
          <li>其他方式取款，需身份证明</li>
        </ul>
      </div>
      <div class="btnCon" :class="pageType == 'app' ? 'only' : ''">
        <span v-if="pageType != 'app'" @click="closeBankPop">取消</span>
        <span @click="goPersonalInfo">去认证</span>
      </div>
    </div>
  </div>
</template>
<style>
.new-withdrawal-certify ul.my-ul {
  list-style: decimal;
  font-size: 0.28rem;
  padding-left: 0.6rem;
  margin-top: 0.3rem;
  /* text-align: center; */
}
.new-withdrawal-certify ul.my-ul li {
  list-style: decimal;
}
.new-withdrawal-certify ul.my-ul li:not(:first-child) {
  margin-top: 0rem;
}
.new-withdrawal-certify.popFixed .tcCon .item ul span {
  display: inline-flex;
}
.new-withdrawal-certify ul .red {
  color: red;
  font-weight: bold;
}
.new-withdrawal-certify ul .blue {
  color: #0a95ff;
}
</style>
<script>
export default {
  name: 'FirstWithdrawal',
  props: ['source', 'isFirstWithdrawalPop', 'pageType', 'isUSDT'],
  data() {
    return {
      isShow: this.isFirstWithdrawalPop,
      topHeight: ''
    }
  },
  methods: {
    flexCenter() {
      const clientHeight =
        document.body.clientHeight || document.documentElement.clientHeight
      const boxHeight = document.getElementById('tcConHeight')
      this.topHeight = (clientHeight - boxHeight) / 2 + 'px'
    },
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    closeBankPop() {
      if (this.pageType != 'app') {
        if (this.source == 'home') {
          this.removeFixed()
          this.isShow = false
          this.$emit('changeFirstWithdrawal', this.isShow)
        } else {
          this.$router.go(-1)
        }
      }
    },
    goPersonalInfo() {
      this.$bus.$emit('loading', false)
      this.$router.push({
        path: '/home/personalInfo'
      })
    }
  }
}
</script>
